import { useEffect } from 'react';
import { warnLayoutOverflow } from '../lib/layoutContainment';

const ENABLED =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_LAYOUT_OVERFLOW_WATCH !== '0';

/**
 * Periodically scans the dashboard root for containers with escaping content.
 * Enable with REACT_APP_LAYOUT_OVERFLOW_WATCH=1 (default on in development).
 */
export default function useLayoutOverflowWatch(rootRef, deps = []) {
  useEffect(() => {
    if (!ENABLED) return undefined;

    let raf = 0;
    let timer = null;

    const scan = () => {
      const root = rootRef?.current;
      if (root) warnLayoutOverflow(root);
    };

    const schedule = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(scan);
    };

    schedule();
    timer = window.setInterval(schedule, 4000);

    const ro =
      typeof ResizeObserver !== 'undefined' && rootRef?.current
        ? new ResizeObserver(schedule)
        : null;
    if (ro && rootRef.current) ro.observe(rootRef.current);

    window.addEventListener('resize', schedule);

    return () => {
      cancelAnimationFrame(raf);
      if (timer) window.clearInterval(timer);
      if (ro) ro.disconnect();
      window.removeEventListener('resize', schedule);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rootRef, ...deps]);
}
